import React, { Component, Fragment} from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { Typography, Divider, Button, TextField, Grid   } from '@material-ui/core';
import { updateUser} from '../../../../../store/Actions/memberActions/memberActions'
import VerifyIcon from '@material-ui/icons/VerifiedUser'
import Tooltip from '@material-ui/core/Tooltip';


const styles = theme => ({
  container: {
  
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  
  },
  myField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
    maxWidth: '500px',
    WebkitBoxShadow: '0 0 0 1000px white inset' 
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
});

class CompanyProfileForm extends Component {

  constructor(props){
    super(props);
    this.state = {
      company: '',
      email: '',
      name: '',
      website: '',
      id: ' '
     
    }
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
   }
   handleSubmit = (e) => {
      e.preventDefault();
      this.props.updateUser(this.state)
   }
   UNSAFE_componentWillReceiveProps(nextProps, prevState){
    if(nextProps.profile.id !== this.state.id){
     // console.log('nije isto')
      this.setState({
        company: nextProps.profile.company,
        email: nextProps.profile.email,
        name: nextProps.profile.name,
        website: nextProps.profile.website,
        id: nextProps.profile.id
      })
    }
   }
  componentDidMount(){
    //console.log('component did mpount', this.props.profile)
    this.setState({
        company: this.props.profile.company,
        email: this.props.profile.email,
        name: this.props.profile.name,
        website: this.props.profile.website,
        id: this.props.profile.id,
        verification: this.props.auth.emailVerified
     })
  }
  render() {
    const { classes } = this.props
    const { company, website, email, name, verification} = this.state
    var appButtonBg = sessionStorage.getItem('buttonBgColor')
    var appButtonLink = sessionStorage.getItem('buttonColor')
    //console.log('CPF', this.props, this.state, verification)
    let accountVer, title
    if (verification === 'true' ){
      accountVer = "green"
      title="Account is Veryfied"
    } else {
      accountVer = "red"
      title="Account is not Veryfied"
    }
   // console.log('AccountVer', accountVer)
      return (
      <Fragment>
       <Grid container>
         <Grid item>
            <Typography component="h1" variant="h5">
              Company Information
            </Typography>
            <Typography component="p" style={{marginTop: '12px', marginBottom: '24px'}}>
              There is alittle line below this heading that explains what information you can put in this section.
           </Typography>
         </Grid>
         <Grid style={{flexGrow: '1', textAlign: 'right'}} item>
            <Tooltip title={title}>
                <VerifyIcon  style={{fill:accountVer, fontSize: '2.5rem'}} />
             </Tooltip>
         </Grid>
       
       </Grid> 
      
      <Divider style={{marginBottom: '24px'}}/>
      <form className={classes.container}
                 style ={{paddingBottom: '24px' }}
                 onSubmit={this.handleSubmit}
                >
          
            <TextField
              disabled
              onChange={this.handleChange}
              variant="outlined"
              className ={classes.myField}
              name="company"
              label="Company Name"
              value={company}
            
              margin="normal"
            />
            <TextField
              onChange={this.handleChange}
              variant="outlined"
              className ={classes.myField}
              name="name"
              label="Your Name"
              value={name}
              margin="normal"
            />
            <TextField
              onChange={this.handleChange}
              variant="outlined"
              className ={classes.myField}
              name="website"
              label="Company Website"
              value={website}
              margin="normal"
            />
             <TextField
              disabled
              onChange={this.handleChange}
              variant="outlined"
              className ={classes.myField}
              name="email"
              label="Company Email"
              value={email}
              margin="normal"
            />
                  <Divider style={{marginTop: '24px'}}/>
                  <Button  variant="contained"   type="submit"  style={{background: appButtonBg, color: appButtonLink  ,marginTop: '24px', padding: '7px 47px'}}>
                        Save
                    </Button>
        </form>
      </Fragment>
    )
  }
}
CompanyProfileForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state)=> {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile  
  };
};

export default withStyles(styles)(connect(mapStateToProps, {updateUser} )(CompanyProfileForm))